import { fabric } from 'fabric';

// Adapted from here https://jsfiddle.net/krunalhshah/qcqa1oe9/
// Extending Fabric line class (https://developer.tizen.org/community/tip-tech/creating-custom-objects-fabric.js)
const LineWithArrow = fabric.util.createClass(fabric.Line, {
  type: 'wavy_line',

  initialize(element, options) {
    options || (options = {});
    this.callSuper('initialize', element, options);

    // Set default options
    this.set({
      objectCaching: false, // Needed to prevent artefacts https://stackoverflow.com/questions/48567482/fabricjs-tips-of-arrows-rendering-with-artefacts-when-being-dragged
      hasBorders: false,
      hasControls: false,
    });
  },

  _render(ctx) {
    ctx.save();
    const xDiff = this.x2 - this.x1;
    const yDiff = this.y2 - this.y1;
    const angle = Math.atan2(yDiff, xDiff);
    ctx.translate((this.x2 - this.x1) / 2, (this.y2 - this.y1) / 2);
    ctx.rotate(angle);
    ctx.beginPath();
    // Move 5px in front of line to start the arrow so it does not have the square line end showing in front (0,0)
    ctx.moveTo(5, 0);
    ctx.lineTo(-5, 5);
    ctx.lineTo(-5, -5);
    ctx.closePath();
    ctx.fillStyle = this.stroke;
    ctx.fill();
    ctx.restore();
    const p = this.calcLinePoints();
    const point = this.pointOnLine(this.point(p.x2, p.y2), this.point(p.x1, p.y1), 10);
    this.wavy(this.point(p.x1, p.y1), point, this.point(p.x2, p.y2), ctx);
    ctx.stroke();
  },

  point(x, y) {
    return {
      x,
      y,
    };
  },

  wavy(from, to, endPoint, ctx) {
    let cx = 0;
    let cy = 0;
    const fx = from.x;
    const fy = from.y;
    const tx = to.x;
    const ty = to.y;
    let i = 0;
    const step = 1;
    let waveOffsetLength = 0;

    const ang = Math.atan2(ty - fy, tx - fx);
    const distance = Math.sqrt(((fx - tx) * (fx - tx)) + ((fy - ty) * (fy - ty)));
    const amplitude = -5; // Wave width
    const f = (Math.PI * distance) / 15; // Wave spacing

    for (i; i <= distance; i += step) {
      waveOffsetLength = Math.sin((i / distance) * f) * amplitude;
      cx = from.x + Math.cos(ang) * i + Math.cos(ang - Math.PI / 2) * waveOffsetLength;
      cy = from.y + Math.sin(ang) * i + Math.sin(ang - Math.PI / 2) * waveOffsetLength;
      if (i > 0) {
        ctx.lineTo(cx, cy);
      } else {
        ctx.moveTo(cx, cy);
      }
    }
    ctx.lineTo(to.x, to.y);
    ctx.lineTo(endPoint.x, endPoint.y);
  },

  pointOnLine(point1, point2, dist) {
    const len = Math.sqrt(((point2.x - point1.x) * (point2.x - point1.x)) + ((point2.y - point1.y) * (point2.y - point1.y)));
    const t = (dist) / len;
    const x3 = ((1 - t) * point1.x) + (t * point2.x);
    const y3 = ((1 - t) * point1.y) + (t * point2.y);
    return new fabric.Point(x3, y3);
  },

  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      customProps: this.customProps,
    });
  },
});

export default LineWithArrow;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Items/WavyLine.js